export default __webpack_public_path__ + "static/media/wonderland-nav-header.d3b8d593.svg";